import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import Fade from '@mui/material/Fade';
import {
  ThreadQuickActions,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/ThreadQuickActions';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';

const useStyles = buildUseStyles('ThreadQuickActions', () => ({
  root: {},
  hidden: {
    display: 'none',
  },
}));
const ThreadListItemQuickActions = ({
  threadResource,
  isHovered,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  const show = isHovered || isMobile;

  return (
    <Fade in={show}>
      <ThreadQuickActions
        className={classNames(classes.root, { [classes.hidden]: !show })}
        threadResource={threadResource}
        size={'small'}
      />
    </Fade>
  );
};

ThreadListItemQuickActions.defaultProps = {
  isHovered: false,
};

ThreadListItemQuickActions.propTypes = {
  threadResource: PropTypes.instanceOf(fr.Resource).isRequired,
  isHovered: PropTypes.bool,
};

export { ThreadListItemQuickActions };
